/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Features_Day_Today_AtInputs */

const en_features_day_today_at = /** @type {(inputs: Features_Day_Today_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Today ${i?.time}`)
};

const pl_features_day_today_at = /** @type {(inputs: Features_Day_Today_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dziś ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Today {time}" |
*
* @param {Features_Day_Today_AtInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_day_today_at = /** @type {((inputs: Features_Day_Today_AtInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Day_Today_AtInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_day_today_at(inputs)
	return en_features_day_today_at(inputs)
});